import React from 'react';
import { Link } from 'gatsby';
import { GatsbySeo, ProductJsonLd } from 'gatsby-plugin-next-seo';
import Container from '@mui/material/Container';
import PageLayout from '../../containers/PageLayout';
import * as styles from './index.module.css';

export interface MarkdownRemark {
  id: string;
  fields: {
    slug: string;
  };
  // excerpt: string;
  html: string;
  frontmatter: {
    url: string;
    title: string;
    date: string;
    destopicscription: string;
    topics: string;
    thumbnail: {
      childImageSharp: {
        gatsbyImageData: any;
      };
    };
  };
}

interface Props {
  data: {
    markdownRemark: MarkdownRemark;
  };
}

const ContentPage: React.FC<Props> = ({ data }) => {
  const page = data.markdownRemark;

  return (
    <PageLayout>
      <GatsbySeo
        title={page.frontmatter.title}
        description={page.frontmatter.description}
        titleTemplate="%s | Pagani Design Watch Official Store"
      />
      <Container disableGutters maxWidth="lg" sx={{ p: 2 }}>
        <article className={styles.contentPage} itemScope itemType="http://schema.org/Article">
          <header>
            <h1 itemProp="headline">{page.frontmatter.title}</h1>
          </header>
          <section dangerouslySetInnerHTML={{ __html: page.html }} itemProp="articleBody" />
        </article>
      </Container>
    </PageLayout>
  );
};

export default ContentPage;
